<script setup>
//ReportsFiltersDateRange
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { DATE_RANGE_OPTIONS } from '../../constants';

const props = defineProps({
  defaultOption: {
    type: String,
    default: 'LAST_7_DAYS',
  },
  maxDateRangeOption: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['onRangeChange']);

const { t } = useI18n();

const allOptions = computed(() =>
  Object.values(DATE_RANGE_OPTIONS).map(option => ({
    ...option,
    name: t(option.translationKey),
  }))
);

const options = computed(() => {
  if (!props.maxDateRangeOption) {
    return allOptions.value;
  }

  const maxIndex = allOptions.value.findIndex(
    opt => opt.id === props.maxDateRangeOption
  );

  if (maxIndex === -1) {
    return allOptions.value;
  }

  return allOptions.value.slice(0, maxIndex + 1);
});

const getInitialOption = () => {
  const defaultOpt = DATE_RANGE_OPTIONS[props.defaultOption];
  
  if (defaultOpt) {
    const isAllowed = !props.maxDateRangeOption || 
      allOptions.value.findIndex(opt => opt.id === props.defaultOption) <= 
      allOptions.value.findIndex(opt => opt.id === props.maxDateRangeOption);
    
    if (isAllowed) {
      return defaultOpt.id;
    }
  }
  
  return options.value[0]?.id;
};

const selectedId = ref(getInitialOption());

const selectedOption = computed({
  get() {
    return options.value.find(o => o.id === selectedId.value);
  },
  set(val) {
    selectedId.value = val.id;
  },
});

const updateRange = range => {
  selectedOption.value = range;
  emit('onRangeChange', range);
};

// Sem emit no mount: o período inicial cada pai já monta sozinho
// (FilterSelector e FilterSelectorRoundRobin emitem no próprio mounted). O emit
// aqui fazia a página do relatório pedir TUDO 2× ao abrir (summary, gráficos,
// cobertura) e furava a espera do time padrão no Round Robin.
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="id"
      label="name"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateRange"
    />
  </div>
</template>